import { IJsonSerializable } from "../util/interfaces"
import { OpArticle } from "../core/op-article"

export class OpEquipmentType implements IJsonSerializable {

    // #region Members

    public article: OpArticle
    public quantity: number

    // #endregion

    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion

    // #region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.article = opObj.Article != null ? new OpArticle(opObj.Article) : null
            this.quantity = opObj.Quantity
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            Article: this.article.toJSON(),
            Quantity: this.quantity
        }
    }

    // #endregion

}